import { useState } from 'react'
import { Wrapper, Image, ContentWrapper, Text, ReadMore } from '@/components/widgets/blog/ImageContent.styles'
import Link from 'next/link'
import { Spacing, Heading } from '@big-red-group/storefront-common-ui'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

export type ImageContentProps = {
  image: string
  heading: string
  text: string
  reverse: boolean
  link?: string
  truncateText?: boolean
}

const ImageContent: React.FC<ImageContentProps> = ({
  image,
  heading,
  text,
  reverse = false,
  link,
  truncateText = false,
}) => {
  const maxCharCount = 240
  const [showMore, setShowMore] = useState(false)
  const showMoreLess = () => {
    setShowMore(!showMore)
  }

  return (
    <>
      <Spacing size="XL" />
      <Wrapper>
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <Image image={image} reverse={reverse} data-testid="image" />
        <ContentWrapper>
          {link ? (
            <Link href={link}>
              <Heading size="M">{heading}</Heading>
            </Link>
          ) : (
            <Heading size="L">{heading}</Heading>
          )}
          <Text truncate={text.length > maxCharCount} showMore={showMore}>
            <ReactMarkdown rehypePlugins={[rehypeRaw]}>{text}</ReactMarkdown>
          </Text>
          {truncateText && text.length > maxCharCount && (
            <ReadMore onClick={() => showMoreLess()} data-testid="read-more">
              <Heading size="XS" headingGraphic="stroke" as="div" spacing={false}>
                {showMore ? 'Show less...' : 'Read more...'}
              </Heading>
            </ReadMore>
          )}
        </ContentWrapper>
      </Wrapper>
      <Spacing size="XL" />
    </>
  )
}

export default ImageContent
